/** Zona 1: busca, filtros rápidos e clientes → lotes com checkbox. */
import React, { useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";

import { FILTROS, SELO, formatarData } from "../../utils/apontamentos";
import { hojeIso } from "../../utils/capacidade/calendario";
import { Bloco, Busca, Chips, LinhaCheck, ListaDeClientes, Selo, Vazio } from "./styles";

function textoDoSelo(selo) {
  if (selo.tipo === SELO.NOVO) return { texto: "Novo", tom: "info" };
  const dia = formatarData(hojeIso(new Date(selo.em))).slice(0, 5);
  if (selo.tipo === SELO.REOTIMIZADO) return { texto: "Reotimizado", tom: "warning", titulo: `Impresso em ${dia}, antes da nova otimização` };
  return { texto: `Impresso ${dia}`, tom: null };
}

function SeloDoLote({ selo }) {
  const { texto, tom, titulo } = textoDoSelo(selo);
  return <Selo $tom={tom} title={titulo}>{texto}</Selo>;
}

/** Checkbox do cliente: marcado, desmarcado ou "parte" (indeterminado). */
function CheckDoCliente({ lotes, selecionados, onAlternar, cliente }) {
  const ref = useRef(null);
  const marcados = lotes.filter((lote) => selecionados.has(lote.chave)).length;
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = marcados > 0 && marcados < lotes.length;
  }, [marcados, lotes.length]);
  return (
    <LinhaCheck>
      <input
        ref={ref}
        type="checkbox"
        checked={marcados === lotes.length}
        onChange={() => onAlternar(lotes, marcados < lotes.length)}
        aria-label={`Marcar todos os lotes de ${cliente}`}
      />
      <span className="principal">{cliente}</span>
      <span className="secundario">{lotes.length === 1 ? "1 lote" : `${lotes.length} lotes`}</span>
    </LinhaCheck>
  );
}

export default function ListaLotes({
  grupos, selecionados, selos, busca, onBusca, filtro, onFiltro, onAlternarLote, onAlternarCliente, buscaRef, totalNoFiltro,
}) {
  return (
    <Bloco aria-labelledby="titulo-lotes">
      <header>
        <span className="passo" aria-hidden="true">1</span>
        <h2 id="titulo-lotes">Clientes e lotes</h2>
      </header>
      <Busca>
        <FiSearch size={15} aria-hidden="true" />
        <input
          ref={buscaRef}
          type="search"
          value={busca}
          onChange={(e) => onBusca(e.target.value)}
          placeholder="Cliente ou número do lote"
          aria-label="Buscar cliente ou lote"
        />
        <kbd aria-hidden="true">/</kbd>
      </Busca>
      <Chips role="group" aria-label="Filtrar lotes">
        {FILTROS.map((opcao) => (
          <button key={opcao.id} type="button" aria-pressed={filtro === opcao.id} onClick={() => onFiltro(opcao.id)}>
            {opcao.rotulo}
          </button>
        ))}
      </Chips>
      {grupos.length === 0 ? (
        <Vazio>
          {totalNoFiltro === 0 && filtro === "nao_impressos"
            ? "Todos os lotes em aberto já foram impressos. Use o filtro Todos para reimprimir."
            : "Nenhum lote encontrado."}
        </Vazio>
      ) : (
        <ListaDeClientes>
          {grupos.map(({ cliente, lotes }) => (
            <li key={cliente}>
              <CheckDoCliente cliente={cliente} lotes={lotes} selecionados={selecionados} onAlternar={onAlternarCliente} />
              {lotes.map((lote) => (
                <LinhaCheck key={lote.chave} $lote>
                  <input
                    type="checkbox"
                    checked={selecionados.has(lote.chave)}
                    onChange={() => onAlternarLote(lote)}
                    aria-label={`Lote ${lote.rotulo}`}
                  />
                  <span className="principal">
                    <span className="mono">Lote {lote.numero}</span>
                    <span className="secundario">
                      {" · "}{lote.ambientes.length === 1 ? "1 amb." : `${lote.ambientes.length} amb.`}
                      {" · otim. "}{formatarData(lote.otimizacao).slice(0, 5)}
                    </span>
                  </span>
                  <SeloDoLote selo={selos.get(lote.chave)} />
                </LinhaCheck>
              ))}
            </li>
          ))}
        </ListaDeClientes>
      )}
    </Bloco>
  );
}
